// HYK-1115: single rendering point for the embedded Stripe Connect
// onboarding component, shared by the registration and publish flows.
import React from 'react';
import { ConnectAccountOnboarding, ConnectComponentsProvider } from '@stripe/react-connect-js';

const EMBEDDED_ONBOARDING_COLLECTION_OPTIONS = {
  fields: 'currently_due',
  futureRequirements: 'omit',
};

const StripeEmbeddedOnboarding = ({ connectInstance, onExit }) => {
  if (!connectInstance) return null;

  return (
    <ConnectComponentsProvider connectInstance={connectInstance}>
      <ConnectAccountOnboarding onExit={onExit} collectionOptions={EMBEDDED_ONBOARDING_COLLECTION_OPTIONS} />
    </ConnectComponentsProvider>
  );
};

export default StripeEmbeddedOnboarding;
